import { useState } from 'react';
import { useApi } from '@bumble/app/hooks/use-api';
import { apiError } from '@bumble/app/utils/api-error';
import { Box, Button, TextField } from '@mui/material';
import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';

interface RouterSiteEditProps {
  onSubmit: () => void;
  cpeId: string;
  cpeName: string;
  siteAddress: string;
  providerServiceID?: string;
  clientCircuitID?: string;
  pingDnsIp?: string;
  pingEmailNotification?: string;
  pingWebhookNotification?: string;
  defaultGatewayIP?: string;
}
export const RouterSiteEdit = ({
  onSubmit, cpeId, cpeName, siteAddress, providerServiceID, clientCircuitID,
  pingDnsIp, pingEmailNotification, pingWebhookNotification, defaultGatewayIP,
}: RouterSiteEditProps) => {
  const api = useApi();
  const [newCpeName, setNewCpeName] = useState<string>(cpeName);
  const [newSiteAddress, setNewSiteAddress] = useState<string>(siteAddress);
  const [newProviderServiceID, setNewProviderServiceID] = useState<string | undefined>(providerServiceID);
  const [newClientCircuitID, setNewClientCircuitID] = useState<string | undefined>(clientCircuitID);
  const [newPingDnsIp, setNewPingDnsIp] = useState<string | undefined>(pingDnsIp);
  const [newPingEmailNotification, setPingEmailNotification] = useState<string | undefined>(pingEmailNotification);
  const [newPingWebhookNotification, setPingWebhookNotification]
    = useState<string | undefined>(pingWebhookNotification);
  const [newDefaultGatewayIP, setNewDefaultGatewayIP] = useState<string | undefined>(defaultGatewayIP);

  const SiteUpdatePost = useMutation(api.updateCpeInfoApiV1UpdateCpeInfoPost, {
    onSuccess() {
      toast.success('Updated CPE info successfully.');
      onSubmit();
    },
    onError: apiError,
  });

  const handleSubmit = () => {
    SiteUpdatePost.mutate({
      cpe_id: cpeId,
      cpe_name: newCpeName,
      site_address: newSiteAddress,
      provider_service_id: newProviderServiceID,
      client_circuit_id: newClientCircuitID,
      ping_dns_ip: newPingDnsIp,
      ping_email_notification: newPingEmailNotification,
      ping_webhook_notification: newPingWebhookNotification,
      ping_gw_ip: newDefaultGatewayIP,
    });
  };

  return (
    <Box pt={2}>
      <TextField
        sx={{ mb: 4 }}
        fullWidth
        label="Device ID"
        variant="outlined"
        value={cpeId}
        disabled
      />
      <TextField
        sx={{ mb: 4 }}
        fullWidth
        label="Name"
        variant="outlined"
        value={newCpeName}
        onChange={(e) => setNewCpeName(e.target.value)}
        autoFocus
      />
      <TextField
        sx={{ mb: 4 }}
        fullWidth
        label="Site Address"
        variant="outlined"
        value={newSiteAddress}
        onChange={(e) => setNewSiteAddress(e.target.value)}
      />
      <TextField
        sx={{ mb: 4 }}
        fullWidth
        label="Provider Service ID"
        variant="outlined"
        value={newProviderServiceID}
        onChange={(e) => setNewProviderServiceID(e.target.value)}
      />
      <TextField
        sx={{ mb: 4 }}
        fullWidth
        label="Client Circuit ID"
        variant="outlined"
        value={newClientCircuitID}
        onChange={(e) => setNewClientCircuitID(e.target.value)}
      />
      <TextField
        sx={{ mb: 4 }}
        fullWidth
        label="Ping Dns Ip"
        variant="outlined"
        value={newPingDnsIp}
        onChange={(e) => setNewPingDnsIp(e.target.value)}
      />
      <TextField
        sx={{ mb: 4 }}
        fullWidth
        label="Default Gateway IP"
        variant="outlined"
        value={newDefaultGatewayIP}
        onChange={(e) => setNewDefaultGatewayIP(e.target.value)}
      />
      <TextField
        sx={{ mb: 4 }}
        fullWidth
        label="Email Address for Alert Notification"
        variant="outlined"
        value={newPingEmailNotification}
        onChange={(e) => setPingEmailNotification(e.target.value)}
      />
      <TextField
        sx={{ mb: 4 }}
        fullWidth
        label="Webhook URL for Alert Notification"
        variant="outlined"
        value={newPingWebhookNotification}
        onChange={(e) => setPingWebhookNotification(e.target.value)}
      />
      <Box display="flex" justifyContent="flex-end" sx={{ mt: 5 }}>
        <Button variant="outlined" onClick={handleSubmit} disabled={!(newCpeName && newSiteAddress)}>
          Save CPE info
        </Button>
      </Box>
    </Box>
  );
};
